/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBatteryMinus: {
  name: 'battery-minus';
  data: string;
} = {
  name: 'battery-minus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 8a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8Zm15 0H4v8h13V8Zm5 1a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1ZM8 11a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2H8Z" fill="currentColor"/></svg>`,
};
